import axios from 'axios'

const API_URL = process.env.REACT_APP_API_URL
const STATISTICS_URL = `${API_URL}/statistics`

export function findAll() {
  return axios.get(`${STATISTICS_URL}`)
}
